const top50Overview = [
  {
      "city": "New York City",
      "country": "USA",
      "millionaires": 349500,
      "centiMillionaires": 744,
      "billionaires": 60,
      "centiGrowth": 48
  },
  {
      "city": "The Bay Area",
      "country": "USA",
      "millionaires": 305700,
      "centiMillionaires": 675,
      "billionaires": 68,
      "centiGrowth": 82
  },
  {
      "city": "Tokyo",
      "country": "Japan",
      "millionaires": 298300,
      "centiMillionaires": 267,
      "billionaires": 14,
      "centiGrowth": -5
  },
  {
      "city": "Singapore",
      "country": "Singapore",
      "millionaires": 244800,
      "centiMillionaires": 336,
      "billionaires": 30,
      "centiGrowth": 64
  },
  {
      "city": "London",
      "country": "UK",
      "millionaires": 227000,
      "centiMillionaires": 370,
      "billionaires": 35,
      "centiGrowth": -10
  },
  {
      "city": "Los Angeles",
      "country": "USA",
      "millionaires": 212100,
      "centiMillionaires": 496,
      "billionaires": 43,
      "centiGrowth": 45
  },
  {
      "city": "Paris & Île-de-France",
      "country": "France",
      "millionaires": 165000,
      "centiMillionaires": 286,
      "billionaires": 23,
      "centiGrowth": 12
  },
  {
      "city": "Sydney",
      "country": "Australia",
      "millionaires": 147000,
      "centiMillionaires": 205,
      "billionaires": 20,
      "centiGrowth": 34
  },
  {
      "city": "Hong Kong",
      "country": "Hong Kong (SAR China)",
      "millionaires": 143400,
      "centiMillionaires": 320,
      "billionaires": 35,
      "centiGrowth": -4
  },
  {
      "city": "Beijing",
      "country": "China",
      "millionaires": 125600,
      "centiMillionaires": 347,
      "billionaires": 42,
      "centiGrowth": 90
  },
  {
      "city": "Shanghai",
      "country": "China",
      "millionaires": 123400,
      "centiMillionaires": 322,
      "billionaires": 39,
      "centiGrowth": 84
  },
  {
      "city": "Chicago",
      "country": "USA",
      "millionaires": 120500,
      "centiMillionaires": 290,
      "billionaires": 24,
      "centiGrowth": 22
  },
  {
      "city": "Toronto",
      "country": "Canada",
      "millionaires": 106300,
      "centiMillionaires": 195,
      "billionaires": 18,
      "centiGrowth": 25
  },
  {
      "city": "Milan & Lombardy",
      "country": "Italy",
      "millionaires": 104500,
      "centiMillionaires": 165,
      "billionaires": 15,
      "centiGrowth": 20
  },
  {
      "city": "Melbourne",
      "country": "Australia",
      "millionaires": 97900,
      "centiMillionaires": 112,
      "billionaires": 10,
      "centiGrowth": 40
  },
  {
      "city": "Frankfurt",
      "country": "Germany",
      "millionaires": 94500,
      "centiMillionaires": 155,
      "billionaires": 15,
      "centiGrowth": 14
  },
  {
      "city": "Houston",
      "country": "USA",
      "millionaires": 90900,
      "centiMillionaires": 258,
      "billionaires": 18,
      "centiGrowth": 70
  },
  {
      "city": "Zurich (canton)",
      "country": "Switzerland",
      "millionaires": 88400,
      "centiMillionaires": 205,
      "billionaires": 10,
      "centiGrowth": 20
  },
  {
      "city": "Seoul",
      "country": "South Korea",
      "millionaires": 82500,
      "centiMillionaires": 195,
      "billionaires": 20,
      "centiGrowth": 28
  },
  {
      "city": "Geneva (canton)",
      "country": "Switzerland",
      "millionaires": 79800,
      "centiMillionaires": 244,
      "billionaires": 14,
      "centiGrowth": 36
  },
  {
      "city": "Dubai",
      "country": "UAE",
      "millionaires": 72500,
      "centiMillionaires": 212,
      "billionaires": 15,
      "centiGrowth": 78
  },
  {
      "city": "Dallas",
      "country": "USA",
      "millionaires": 68600,
      "centiMillionaires": 125,
      "billionaires": 15,
      "centiGrowth": 75
  },
  {
      "city": "Munich",
      "country": "Germany",
      "millionaires": 68400,
      "centiMillionaires": 85,
      "billionaires": 11,
      "centiGrowth": 22
  },
  {
      "city": "Mumbai",
      "country": "India",
      "millionaires": 58800,
      "centiMillionaires": 236,
      "billionaires": 29,
      "centiGrowth": 82
  },
  {
      "city": "Rome & Lazio",
      "country": "Italy",
      "millionaires": 57600,
      "centiMillionaires": 92,
      "billionaires": 10,
      "centiGrowth": 5
  },
  {
      "city": "Seattle",
      "country": "USA",
      "millionaires": 54200,
      "centiMillionaires": 130,
      "billionaires": 11,
      "centiGrowth": 72
  },
  {
      "city": "Shenzhen",
      "country": "China",
      "millionaires": 50300,
      "centiMillionaires": 154,
      "billionaires": 22,
      "centiGrowth": 140
  },
  {
      "city": "Amsterdam",
      "country": "Netherlands",
      "millionaires": 45200,
      "centiMillionaires": 91,
      "billionaires": 9,
      "centiGrowth": 33
  },
  {
      "city": "Osaka",
      "country": "Japan",
      "millionaires": 43100,
      "centiMillionaires": 69,
      "billionaires": 5,
      "centiGrowth": -12
  },
  {
      "city": "Boston",
      "country": "USA",
      "millionaires": 42900,
      "centiMillionaires": 107,
      "billionaires": 8,
      "centiGrowth": 55
  },
  {
      "city": "Vancouver",
      "country": "Canada",
      "millionaires": 41400,
      "centiMillionaires": 80,
      "billionaires": 10,
      "centiGrowth": 50
  },
  {
      "city": "Madrid",
      "country": "Spain",
      "millionaires": 36000,
      "centiMillionaires": 74,
      "billionaires": 8,
      "centiGrowth": 8
  },
  {
      "city": "Miami",
      "country": "USA",
      "millionaires": 35300,
      "centiMillionaires": 164,
      "billionaires": 15,
      "centiGrowth": 78
  },
  {
      "city": "Perth",
      "country": "Australia",
      "millionaires": 33600,
      "centiMillionaires": 64,
      "billionaires": 8,
      "centiGrowth": 28
  },
  {
      "city": "Austin",
      "country": "USA",
      "millionaires": 32700,
      "centiMillionaires": 92,
      "billionaires": 10,
      "centiGrowth": 110
  },
  {
      "city": "Hangzhou",
      "country": "China",
      "millionaires": 31600,
      "centiMillionaires": 102,
      "billionaires": 12,
      "centiGrowth": 125
  },
  {
      "city": "Delhi",
      "country": "India",
      "millionaires": 30700,
      "centiMillionaires": 123,
      "billionaires": 16,
      "centiGrowth": 95
  },
  {
      "city": "Moscow",
      "country": "Russian Federation",
      "millionaires": 30300,
      "centiMillionaires": 207,
      "billionaires": 23,
      "centiGrowth": -24
  },
  {
      "city": "Taipei",
      "country": "Taiwan",
      "millionaires": 30200,
      "centiMillionaires": 82,
      "billionaires": 15,
      "centiGrowth": 41
  },
  {
      "city": "Vienna",
      "country": "Austria",
      "millionaires": 29700,
      "centiMillionaires": 70,
      "billionaires": 7,
      "centiGrowth": 22
  },
  {
      "city": "Washington, DC",
      "country": "USA",
      "millionaires": 28300,
      "centiMillionaires": 88,
      "billionaires": 12,
      "centiGrowth": 75
  },
  {
      "city": "Brisbane",
      "country": "Australia",
      "millionaires": 27200,
      "centiMillionaires": 40,
      "billionaires": 4,
      "centiGrowth": 36
  },
  {
      "city": "Berlin",
      "country": "Germany",
      "millionaires": 26500,
      "centiMillionaires": 47,
      "billionaires": 5,
      "centiGrowth": 30
  },
  {
      "city": "Nice to Èze",
      "country": "France",
      "millionaires": 26300,
      "centiMillionaires": 95,
      "billionaires": 9,
      "centiGrowth": 25
  },
  {
      "city": "Stockholm",
      "country": "Sweden",
      "millionaires": 24800,
      "centiMillionaires": 64,
      "billionaires": 12,
      "centiGrowth": 6
  },
  {
      "city": "Guangzhou",
      "country": "China",
      "millionaires": 24500,
      "centiMillionaires": 70,
      "billionaires": 9,
      "centiGrowth": 110
  },
  {
      "city": "Tel Aviv",
      "country": "Israel",
      "millionaires": 24300,
      "centiMillionaires": 82,
      "billionaires": 10,
      "centiGrowth": 45
  },
  {
      "city": "Dublin",
      "country": "Ireland",
      "millionaires": 24200,
      "centiMillionaires": 43,
      "billionaires": 5,
      "centiGrowth": 60
  },
  {
      "city": "Auckland",
      "country": "New Zealand",
      "millionaires": 23400,
      "centiMillionaires": 42,
      "billionaires": 4,
      "centiGrowth": 52
  },
  {
      "city": "Manchester & Trafford",
      "country": "UK",
      "millionaires": 23200,
      "centiMillionaires": 67,
      "billionaires": 7,
      "centiGrowth": 8
  }
];

const centiWorldData = [
  // {
  //     "city": "World",
  //     "country": "=",
  //     "millionaires": "23200",
  //     "centiMillionaires": "28420",
  //     "billionaires": "2350",
  //     "centiGrowth": 38
  // }
];

export {top50Overview, centiWorldData};